<!--坏件库修改页面-->
<template>
  <el-dialog :title="title"
             :visible.sync="dialogFormVisible"
             custom-class="max-dialog"
             center
             :close-on-click-modal="false"
             :modal="true">
    <div>
      <div class="search-content">
        <el-col :span="24" class="toobar">
          <el-col :span="24">
          <el-col :span="3">
            <span class="demonstration">处理方式:</span>
            <el-select v-model="value" placeholder="请选择" style="width: 140px;">
              <el-option
                v-for="item in brokenpartsType"
                :key="item.value"initData
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
            <el-col :span="4" v-if="value==30">
              <el-select v-model="movecangkucode" placeholder="请选择" style="width: 180px;" @change="changenamemove" :required="true"
                         size="max">
                <el-option
                  v-for="item in jxcstoreDataAll"
                  :key="item.cangkucode" v-if="cangkucode!=item.cangkucode"
                  :label="item.cangkuname"
                  :value="item.cangkucode">
                </el-option>
              </el-select>
            </el-col>
          <el-col :span="6" v-if="value==10">
            <el-select v-model="cangcode1" placeholder="请选择" style="width: 150px;" @change="changename" :required="true"
                       size="max">
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
            <el-select v-model="warehouse" size="mini" style="width: 100px" v-if="warehousearr.length>1&&cangcode1" @change="changewarehouse">
              <el-option v-for="item in warehousearr" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="value==20">
            <el-input v-model="pcustomer" auto-complete="off" :required="true"
                      @click.native="changepcustomer" placeholder="请选择供应商"></el-input>
          </el-col>
          <el-col :span="4" v-show="value==5 || value==10 || value==20|| value==30">
            <el-input v-model="remark" placeholder="备注"/>
          </el-col>
          <el-col :span="3" v-if="value==20">
            <el-input v-model="LogisticsNum" placeholder="快递单号"/>
          </el-col>
          <el-col :span="4">总数：{{subnumber}}</el-col>
          </el-col>
          <el-col :span="4">
            <AutoCustomer @clear="clearCustomerName" :size="'small'"
                          @handleSelect="afterSelExternalDept"></AutoCustomer>
          </el-col>
          <el-col :span="18">
           <el-checkbox v-model="showCat" @change="bindGrid()">按系列显示</el-checkbox>
            <el-button @click="selectAll($event,'all')" size="mini">全选</el-button>
            <el-button @click="selectAll($event,'has')" size="mini">含订单</el-button>
            <el-button @click="selectAll($event,'no')" size="mini">无订单</el-button>
            <el-input style="width: 120px" size="small" v-model="onlycode"
                      onfocus="this.select()" placeholder="扫唯一码" @change="toponlyonecode()"></el-input>
            <el-input style="width: 120px" size="small" v-model="scanpowercode"
                      ref="scanpowerInput" onfocus="this.select()" placeholder="扫光度码" @change="scanPowerCode()"></el-input>
            <el-input placeholder="商品名称" size="small" v-model="seedsearch" clearable style="width: 120px" @change="searchData()"></el-input>
            <el-input placeholder="订单号" size="small" v-model="erpserialsearch" clearable style="width: 145px" @change="searchData()"></el-input>
            <el-input placeholder="球镜" size="small" v-model="packagey" clearable style="width: 80px" @change="searchData()"></el-input>
            <el-input placeholder="柱镜" size="small" v-model="packagex" clearable style="width: 80px" @change="searchData()"></el-input>
          </el-col>
        </el-col>
      </div>
      <el-table
        :data="tableData.filter(data => data.show!=-1)"
        :height="tableHeight(260)"
        size="mini"
        stripe :default-sort = "{prop: 'needhandlenumber', order: 'descending'}"
        border v-if="showtable"
        style="width: 100%;">
        <el-table-column
          prop="erpserial" width="120"
          label="坏件入库单号"
          header-align="center"
          align="center" >
          <template slot-scope="scope">
                  <span @click="lookbaosundan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.erpserial}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ordernum"
          label="销售单号"
          header-align="center"
          align="center"
          width="120" >
          <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="buyordernum"
          label="采购单号"
          header-align="center"
          align="center"
          width="120" >
        </el-table-column>
        <el-table-column
          prop="seedname"
          label="名称" width="180"
          :show-overflow-tooltip="true"
          header-align="center"
          align="left">
        </el-table-column>
        <el-table-column
          prop="seedcode"
          label="编码"
          header-align="center"
          width="120" :show-overflow-tooltip="true"
          align="left">
        </el-table-column>
        <el-table-column
          prop="packagesize"
          label="规格"
          align="left" :show-overflow-tooltip="true"
          header-align="center" width="150">
          <template slot-scope="scope">
            {{getPackagesize(scope.row.packagesize)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="customername"
          label="责任人" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="80">
        </el-table-column>
        <el-table-column
          prop="ordername"
          label="类别"
          align="left"
          header-align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="原因" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="200">
        </el-table-column>
        <el-table-column
          prop="accdate"
          label="入库日期"
          header-align="center"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="cangkuname"
          label="仓库"
          header-align="center"
          align="left"
          width="100">
        </el-table-column>
        <el-table-column
          prop="uname"
          label="录入人"
          header-align="center"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="totalnumber" fixed="right"
          label="数量"
          header-align="center"
          align="right"
          width="70">
          <template slot-scope="scope">
            {{(scope.row.totalnumber-scope.row.handlenumber)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="needhandlenumber" fixed="right"
          label="处理数量" width="300"
          header-align="center"
          align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.barcodes&&scope.row.barcodes.length>0">
              <el-checkbox v-for="item in scope.row.barcodes" :checked="ischeck(scope.row,item)" :label="item.storegoodsbarcode" :ref="item.unitguid" :key="item.unitguid" @change="changeBar(scope.row,item,$event)">{{item.storegoodsbarcode}}（{{item.saleordernum?item.saleordernum:'无'}}）</el-checkbox><br/>
            </div>
            <el-input placeholder="请输入数量" width="100px" size="mini" v-else v-model="scope.row.needhandlenumber" @blur="changnum(scope.row)">
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <!--<BrokenPartsEdit ref="DataContactEdit"></BrokenPartsEdit>-->
      <ExternaldeptChaiDanSel ref="zhuandan" :unitgroup="3"
                              @select="selectpcustomer" :title="'选择供应商'"></ExternaldeptChaiDanSel>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid"></CstagreementEdit>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <CstagreementEdit ref="DataContactEditCopy" @bindGrid="bindGrid"></CstagreementEdit>
      <QRCodeScanBad ref="QRCodeScanBad1" @scancodeedit="afterQRCodeScan"></QRCodeScanBad>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" class="qrbtn" @click="update" :loading="loading">确认</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="value==10&&cangkucode&&qrcodescan" :loading="loading">扫码</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {getBadStoreListData,badpartslist} from '@/api/set/warehouse'
  import {updateBrokenparks, detailERPSerial} from '@/api/set/csagreement';
  import StorageBadOut from './StorageBadOut';
  import {getListDatabyinpd, getListDataall, cusandptbyind} from '@/api/set/jxcstore';
  import ExternaldeptChaiDanSel from '@/components/set/externaldept/ExternaldeptChaiDanSel'
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import AutoComplete from "@/components/common/AutoCustomer";
  import QRCodeScanBad from './QRCodeScanBad';
  import {checkModuleRight} from '@/api/login'
  import {bardetail} from '@/api/set/jxcgoodsbarcode'

  export default {
    name: 'StorageBadEdit',
    data() {
      return {
        msg: '坏件出库操作',
        userInfoModel: {},
        customername:'',
        customerserial:'',
        loading:false,
        subnumber:0,
        dialogFormVisible: false,
        searchdata: "",
        seedcode: '',
        onlycode:'',
        scanpowercode:'',
        showCat:false,
        categorycode:'',
        seedsearch:'',
        erpserialsearch:'',
        packagex:'',
        packagey:'',
        seedcodes: '',
        remark: '',
        LogisticsNum: '',
        cangkucode: '',
        cangkuname: '',
        warehouse:'',
        warehousename:'',
        warehousearr:[],
        movecangkucode: '',
        movecangkuname: '',
        jxcstoreDataAll:[],
        jxcstoreDataf: [],
        cangcode1: '',
        cangkuname1: '',
        title: '',
        showtable:true,
        loading: true,
        qrcodescan:false,
        independentserial: "",
        value: '',
        brokenpartsType: [
          {value: 5, name: "损耗"},
          {value: 10, name: "入正式库"},
          {value: 20, name: "退回供应商"},
          {value: 30, name: "转其他仓库"},
        ],
        pcustomer: '',
        pcustomerserial: '',
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],


      }
    },
    methods: {
      delivergoodsScan() {//扫码发货
        var arr = []
        for (let i in this.tableData) {
          if (this.tableData[i]["needhandlenumber"] && this.tableData[i]["needhandlenumber"] > 0) {
            var handleNum = parseInt(this.tableData[i]["needhandlenumber"]);
            for (let m = 0; m < handleNum; m++) {
              arr.push({
                erpserial: this.tableData[i].ordernum,
                seedcode: this.tableData[i].seedcode,
                seedname: this.tableData[i].seedname,
                packagesize: this.tableData[i].packagesize,
                storegoodsbarcode: '', starttime: '', endtime: '',
                pipei:false
              })
            }
          }
        }
        this.$refs.QRCodeScanBad1.show({
          cangkucode: this.cangkucode,
          erpserial: '',
          seedcode: '',
          goods: arr,
          tableData: this.tableData,
        }, true);
      },
      afterQRCodeScan(scancodes) {//扫码后提交
        this.update();
      },
      clearCustomerName() {
        this.customername = ""
        this.customerserial = ""
        this.bindGrid()
      },
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      selectAll(event, type) {
        this.showtable = false
        for (let i in this.tableData) {
          if (this.tableData[i].show == -1)
            continue;//未显示的不做处理

          if (this.tableData[i].barcodes.length == 0) {
            if (type == 'all') {
              this.tableData[i].needhandlenumber = this.tableData[i].totalnumber - this.tableData[i].handlenumber;
            }
          } else {
            for (let j in this.tableData[i].barcodes) {
              if (type == 'all') {
                this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], event);
              } else {
                if (type == 'has') {
                  if (event)
                    this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], this.tableData[i].barcodes[j].saleordernum);
                } else {
                  if (event)
                    this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], !this.tableData[i].barcodes[j].saleordernum);
                }
              }
            }
          }
        }
        this.$nextTick(() => {
          this.showtable = true
        });
      },
      toponlyonecode() {
        if (!this.onlycode)
          return;

        for (let i in this.tableData) {
          for (let j in this.tableData[i].barcodes) {
            if (this.tableData[i].barcodes[j].storegoodsbarcode == this.onlycode) {
              this.showtable = false
              this.onlycode = ''
              this.changeBar(this.tableData[i], this.tableData[i].barcodes[j], true);
              break;
            }
          }
        }
        if (!this.showtable) {
          this.$nextTick(() => {
            this.showtable = true
          });
        }
      },
      //扫光度码（增加处理数量，光度码本身不存库）
      scanPowerCode() {
        if (!this.scanpowercode)
          return;
        const _this = this;
        bardetail({barcode: this.scanpowercode}).then(response => {
          _this.scanpowercode = '';
          if (!response.data.obj || response.data.code != 0 || !response.data.obj.seedcode) {
            _this.$message({ message: '光度码无效！', type: 'error' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          const obj = response.data.obj;
          const seedcode = obj.seedcode;
          const packagesize = obj.packagesize || '';
          let matched = false;
          for (let i in _this.tableData) {
            const row = _this.tableData[i];
            if (row.seedcode == seedcode && (row.packagesize || '') == packagesize) {
              const remaining = (row.totalnumber || 0) - (row.handlenumber || 0);
              if ((row.needhandlenumber || 0) < remaining) {
                row.needhandlenumber = (row.needhandlenumber || 0) + 1;
                _this.subnumber = 0;
                for (let k in _this.tableData) {
                  _this.subnumber += _this.tableData[k].needhandlenumber ? parseInt(_this.tableData[k].needhandlenumber) : 0;
                }
                matched = true;
              } else {
                _this.$message({ message: '该记录可处理数量已满', type: 'warning' });
              }
              break;
            }
          }
          if (!matched) {
            _this.$message({ message: '未找到匹配的处理记录！请核对', type: 'warning' });
          }
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        }).catch(() => {
          _this.scanpowercode = '';
          _this.$message({ message: '光度码查询失败', type: 'error' });
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        });
      },
      ischeck(item, checks) {
        return (item.selectBars.indexOf(';' + checks.unitguid + ';') > -1);
      },
      changeBar(item, checks, event) {
        if (item.selectBars.indexOf(';' + checks.unitguid + ';') > -1) {
          if (!event) {
            item.selectBars = item.selectBars.replace(';' + checks.unitguid + ';', ';');
            item.needhandlenumber -= 1;
            this.subnumber -= 1;
          }
        } else {
          if (event) {
            item.selectBars += checks.unitguid + ';';
            if (item.needhandlenumber)
              item.needhandlenumber += 1;
            else
              item.needhandlenumber = 1;
            this.subnumber += 1;
          }
        }
        console.log(item.selectBars)
      },
      isEqualIndependentSerial(item) {//总部人员只能操作总部的数据，加工中心只能操作加工中心的数据
        return this.userInfoModel.independentserial == (item.independentserial || "")
      },

      selectpcustomer(pcustomerserial, pcustomer) {
        this.pcustomerserial = pcustomerserial
        this.pcustomer = pcustomer
      },
      changepcustomer() {
        this.seedcodes = []
        this.seedcodes.push(this.seedcode)
        this.$refs.zhuandan.initData(this.seedcodes)
        this.$refs.zhuandan.show()
      },

      changnum(item) {
        let res = /^[+]{0,1}(\d+)$/
        let num = item.needhandlenumber;
        if (num) {
          if (num != undefined && !res.test(num)) {
            this.$message({
              message: "请输入正确的数字",
              type: 'error'
            })
            item.needhandlenumber = ''
          } else if (item.totalnumber - item.handlenumber - num < 0) {
            this.$message({
              message: "处理数量需要小于总数",
              type: 'error'
            })
            item.needhandlenumber = ''
          }

          this.subnumber = 0
          for (let i in this.tableData) {
            this.subnumber += this.tableData[i].needhandlenumber ? parseInt(this.tableData[i].needhandlenumber) : 0;
          }
        }
      },
      changewarehouse(val){
        this.warehouse = val;
        for(let i in this.warehousearr){
          if(this.warehousearr[i].serial==val){
            this.warehousename = this.warehousearr[i].name;
            break;
          }
        }
      },
      changename(val) {
        this.warehousearr=[]
        this.warehouse=''
        this.warehousename=''
        for (let i in this.jxcstoreDataf) {
          var row=this.jxcstoreDataf[i];
          if (row.cangkucode == val) {
            this.cangkuname = row.cangkuname;

            if(row.warehouse) {//库存位
              this.warehousearr = JSON.parse(row.warehouse);
              if (this.warehousearr <= 1) {
                this.warehousearr = [];
              } else {
                this.warehouse = this.warehousearr[0].serial;
                this.warehousename = this.warehousearr[0].name;
              }
            }
            break;
          }
        }
      },
      changenamemove(val){
        for (let i in this.jxcstoreDataAll) {
          if (this.jxcstoreDataAll[i].cangkucode == val) {
            this.movecangkuname = this.jxcstoreDataAll[i].cangkuname;
          }
        }
      },
      //查看订单
      lookdingdan(item) {
        if (item["ordernum"]) {
          var s = {
            erpserial: item["ordernum"]
          }
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
          this.$refs.DataContactEdit.yincangdayin('order')
        }
      },
      lookbaosundan(item) {
        this.$refs.BaoSunDetail.show(item.erpserial, false)
      },
      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      errorMsg(msg){
        this.$message({
          message: msg,
          type: 'error'
        })
        this.loading=false;
      },
      update() {
        this.loading = true;
        if (!this.value) {
          this.errorMsg('请选择处理方式');
          return
        }
        if (this.value == 5 && !this.remark) {
          this.errorMsg('请输入损坏原因');
          return
        }
        if (this.value == 10 && !this.cangkucode) {
          this.errorMsg('请选择仓库');
          return
        }
        if (this.value == 30 && !this.movecangkucode) {
          this.errorMsg('请选择仓库');
          return
        }
        if (this.value == 20 && !this.pcustomerserial) {
          this.errorMsg('请选择供应商');
          return;
        }

        let brokenlist = [];
        var barUnitguid = '';
        for (let i in this.tableData) {
          let obj = {
            unitguid: '',
            needhandlenumber: '',
          }
          if (!this.qrcodescan && this.tableData[i].barcodes && this.tableData[i].barcodes.length > 0) {
            var num = 0;
            var bars = this.tableData[i].selectBars.split(';')
            for (var m = 0; m < bars.length; m++) {
              if (bars[m]) {
                barUnitguid += bars[m] + ';';//选择的条码
                num++;
              }
            }
            this.tableData[i]["needhandlenumber"] = num;
          }
          if (this.tableData[i]["needhandlenumber"] && this.tableData[i]["needhandlenumber"] > 0) {
            obj["unitguid"] = this.tableData[i]["unitguid"]
            obj["needhandlenumber"] = this.tableData[i]["needhandlenumber"]
            brokenlist.push(obj)
          }
        }

        if (!(brokenlist && brokenlist.length > 0)) {
          this.errorMsg('请选择退货产品');
          return;
        }

        if (this.value == 10) {
          this.cangkucode = this.cangcode1
        }

        if (this.value == 30) {
          if (this.remark) {
            this.remark += "（从" + this.cangkuname + " 转入" + this.movecangkuname + "）";
          } else
            this.remark = "从" + this.cangkuname + " 转入" + this.movecangkuname;
        }

        var handlemode = ''
        for (let i = 0; i < this.brokenpartsType.length; i++) {
          if (this.value) {
            if (this.brokenpartsType[i].value == this.value) {
              handlemode = this.brokenpartsType[i].name
            }
          }
        }

        // 退回供应商时，检查所选商品是否属于同一销售单号
        var self = this;
        var logisticsPromise = Promise.resolve({logisticstracknum: '', tracknum: ''});
        if (this.value == 20) {
          var ordernums = [];
          for (let i in this.tableData) {
            if (this.tableData[i]["needhandlenumber"] && this.tableData[i]["needhandlenumber"] > 0) {
              if (this.tableData[i].ordernum) {
                ordernums.push(this.tableData[i].ordernum);
              }
            }
          }
          // 去重后检查是否只有一个销售单号
          var uniqueOrdernums = ordernums.filter(function(v, idx, arr) { return arr.indexOf(v) === idx; });
          if (uniqueOrdernums.length === 1) {
            logisticsPromise = detailERPSerial({erpserial: uniqueOrdernums[0]}).then(function(resp) {
              if (resp.data.code == 0 && resp.data.obj) {
                return {
                  logisticstracknum: resp.data.obj.logisticstracknum || '',
                  tracknum: resp.data.obj.tracknum || ''
                };
              }
              return {logisticstracknum: '', tracknum: ''};
            })['catch'](function() {
              return {logisticstracknum: '', tracknum: ''};
            });
          }
        }
        logisticsPromise.then(function(logistics) {
          updateBrokenparks(
            {
              brokenlist: JSON.stringify(brokenlist),
              remark: self.remark,
              cangkucode: self.cangkucode,
              cangkuname: self.cangkuname,
              warehouse: self.warehouse,
              warehousename: self.warehousename,
              movecangkucode: self.movecangkucode,
              movecangkuname: self.movecangkuname,
              pcustomerserial: self.pcustomerserial,
              pcustomer: self.pcustomer,
              value: self.value,
              barunitguid: barUnitguid,
              handlemode: handlemode,
              logisticstracknum: logistics.logisticstracknum,
              tracknum: logistics.tracknum,
              logisticsnum: self.LogisticsNum
            }
          ).then(function(response) {
            if (response.data.code == 0) {
              self.$message({
                message: '保存成功',
                type: 'success'
              })
              if (self.$refs.QRCodeScanBad1) {//退货出库的时候需要保存 唯一码
                self.$refs.QRCodeScanBad1.saveQRCode(response.data.erpserial);
              }
              self.$refs.StorageBadOut.show(response.data.erpserial);
              self.$emit('bindGrid');
              self.dialogFormVisible = false;
            } else {
              self.errorMsg(response.data.msg);
            }
            self.loading = false;
          })
        })
      },
      initData(item) {
        this.loading=false;
        this.categorycode = item.CategoryCode
        this.seedcode = item.seedcode
        this.cangkucode = item.cangkucode
        this.cangkuname = item.cangkuname
        this.cangcode1 = this.jxcstoreDataf[0].cangkucode
        if(item.cangkucode==this.jxcstoreDataAll[0].cangkucode){
          this.movecangkucode=''
          this.movecangkuname=''
        }else {
          this.movecangkucode = this.jxcstoreDataAll[0].cangkucode
          this.movecangkuname = this.jxcstoreDataAll[0].cangkuname
        }
        this.pcustomerserial = ''
        this.pcustomer = ''
        this.remark = ''
        this.LogisticsNum = ''
        this.title = item.seedname + "坏件处理"
        this.value = ''
        this.subnumber = 0;
        this.customerserial = ''
        this.customername = ''
        this.seedsearch = ''
        this.erpserialsearch = ''
        this.packagex = ''
        this.packagey = ''
        this.changename(this.cangcode1);
        this.bindGrid();
        this.$nextTick(() => {
          if (this.$refs.scanpowerInput) {
            this.$refs.scanpowerInput.focus();
          }
        });
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            s=temp.M+'-'+temp.C
          } else {
            s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          }
          if (temp.type) {
            s = temp.type + " " + s
          }
        }
        return s
      },
      searchData() {
        this.showtable = false;
        for (var i = 0; i < this.tableData.length; i++) {
          var row = this.tableData[i];
          row.show = 1;
          if (row.needhandlenumber > 0) {
            continue;
          }
          if (this.erpserialsearch) {
            if (!((row.buyordernum && this.erpserialsearch.indexOf(row.buyordernum)>-1) ||
              (row.ordernum && this.erpserialsearch.indexOf(row.ordernum)>-1))||(!row.buyordernum&&!row.ordernum)) {
              row.show = -1;
              continue;
            }
          }

          if(this.packagey||this.packagex){
            if(row.packagesize) {
              var pg = JSON.parse(row.packagesize);
              if ((this.packagey && parseFloat(this.packagey) != parseFloat(pg.Y))||
                (this.packagex && parseFloat(this.packagex) != parseFloat(pg.X))) {
                row.show = -1;
                continue;
              }
            }else{
              row.show = -1;
              continue;
            }
          }

          if (this.seedsearch) {
            if (!(row.seedcode.indexOf(this.seedsearch) > -1 ||
              row.seedname.indexOf(this.seedsearch) > -1)) {
              row.show = -1;
            }
          }
        }
        this.$nextTick(() => {
          this.showtable = true
        });
      },
      bindGrid() {
        this.tableData = []
        this.dialogFormVisible = true;
        badpartslist({
          formtype: 78,
          seedcode: (this.showCat ? '' : this.seedcode),
          categorycode: (this.showCat ? this.categorycode : ''),
          cangkucode: this.cangkucode,
          status: 20,
          customerserial: this.customerserial
        }).then(response => {
          this.tableData = response.data.obj
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selectBars = ';';
            this.tableData[i].needhandlenumber = '';// this.tableData[i].totalnumber - this.tableData[i].handlenumber
            if (!this.tableData[i].barcodes)
              this.tableData[i].barcodes = [];
          }
          this.searchData();
        })
      },
    },
    components: {
      // BrokenPartsEdit,
      ExternaldeptChaiDanSel,
      CstagreementEdit,
      BaoSunDetail,
      AutoComplete,
      StorageBadOut,
      QRCodeScanBad
    },

    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;

      checkModuleRight({name: 'qrcodescan'}).then(reponse => {
        this.qrcodescan = reponse.data.code == 0;
      });
      cusandptbyind().then(response => {
        this.jxcstoreDataf = response.data.obj
      })
      //全部仓库
      getListDataall().then(response => {
        this.jxcstoreDataAll =response.data.obj
      });
    },

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadEdit.vue